import { getList, publicPage } from './getCostList'
import { deepClone, extendObject } from '@/assets/js/utils'
import { subChannel } from '@/api/wenjuan/answerList'
import { exportPDF, exportDetailExcel } from '@/api/wenjuan/cost'
import { exportExcel } from '@/api/wenjuan/cost'
import GlobalConfig from '@/global/config'

export default {
  props: {
    isAll: {
      type: Boolean,
      default: false
    },
    queryForm: {
      type: Object,
      default: () => ({})
    },
    opt: {
      type: Object,
      default: () => ({})
    },
    filterVal: {
      type: Array,
      default: () => []
    },
    tHeader: {
      type: Array,
      default: () => []
    },
    headerList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      forms: {},
      page: publicPage,
      option: this.opt,
      data: [],
      channelsListOptions: [] // 子渠道options
    }
  },
  methods: {
    DownloadExportPDF() {
      exportPDF(this.handleData())
        .then(res => {
          if(res.data.code === 0) {
            window.open(res.data.data)
          }else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    DownloadExportDetailExcel(type) {
      // let data = {
      //   surveyId: GlobalConfig.getSurveyId(),
      // }
      // data.params ={
      //   awardType:5,// 奖励方式 5-答题奖励 6-分享奖励
      //   channel: 0
      // }
      // if(type === 'answer') {
      //   data.params.awardType = 5
      // } else if(type === 'spread') {
      //   data.params.awardType = 6
      // }
      exportDetailExcel(this.handleData())
        .then(res => {
          if(res.data.code === 0) {
            window.open(res.data.data)
          }else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    // 选择 回收渠道 change事件
    qdsChange(v) {
      // 清空子渠道
      this.forms.channelId = ''
      this.channelsListOptions = []
      this.commonChange()
      if (!v) return
      subChannel(this.forms.channel, GlobalConfig.getSurveyId())
        .then(res => {
          this.channelsListOptions = (res.data && res.data.data) || []
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {})
    },
    // 获取子渠道下拉框
    answerChannelListOptions(channel = 0) {
      // 清空子渠道
      this.isloadingAnswerChannel = true
      subChannel(channel, GlobalConfig.getSurveyId())
        .then(res => {
          this.channelsListOptions = (res.data && res.data.data) || []
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.isloadingAnswerChannel = false
        })
    },
    getList(params) {
      getList.call(this, params)
    },
    // 整理请求数据
    handleData() {
      const fs = deepClone(this.forms)
      const data = {
        surveyId: GlobalConfig.getSurveyId(),
        current: this.page.currentPage,
        size: this.page.pageSize
      }
      let [startTime, endTime] = fs.dates1 || ['', '']
      delete fs.dates1
      const params = {
        startTime,
        endTime,
        awardType: this.type // 5答题奖励；6分享奖励
      }
      extendObject(params, fs)
      if (!this.isAll) {
        // 网络调查 0
        params.channel = 0
      }
      Object.keys(params).forEach(key => {
        // 0 不删除
        if (!params[key] && params[key] !== 0) {
          delete params[key]
        }
      })
      data.params = params
      return data
    },
    commonChange() {
      this.getList(this.handleData())
    },
    // 点击 每页显示条数 触发
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      //   重新渲染
      this.getList(this.handleData())
    },
    // 切换页面 （点击页码、数字、输入数字） 触发
    currentChange(val) {
      this.page.currentPage = val
      //   重新渲染
      this.getList(this.handleData())
    },
    /* formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
    dcE() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/assets/js/Export2Excel")
        const tHeader = this.tHeader
        // 上面设置Excel的表格第一行的标题
        const filterVal = this.filterVal
        // 上面的index、nickName、name是tableData里对象的属性
        const list = this.data //把data里的tableData存到list
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, "excel")
      })
    } */

    init() {
      this.page = {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示多少条
      }
      this.commonChange()
    }
  },
  created() {
    // 获取header信息
    this.getHList()
    // 获取子渠道下拉框 0 网络调查 1督导吧任务 2 面对面访问
    if (!this.isAll) {
      // 不是全部 就是网调0；线下单独文件
      this.answerChannelListOptions(0)
    }
    this.forms = deepClone(this.queryForm)
    this.init()
  }
}
